import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import PageHeader from '../../Components/Page/PageHeader';
import SessionsData from '../../Components/SessionsData';
import Page from '../../Components/Page';

import { selectChargingPoints } from '../../redux/selectors/chargingPoints';

import './style.scss';

function Sessions() {
  const chargingPoints = useSelector(selectChargingPoints);
  const { t } = useTranslation();

  const urlParams = new URLSearchParams(window.location.search);
  const cpId = urlParams.get('cp');
  const currentCp = chargingPoints?.length && chargingPoints.find((cp) => parseInt(cp.id) === parseInt(cpId));
 
  return (
    <Page>
      <PageHeader
        title={currentCp ? `${t('sessions_for')} ${currentCp?.cp_id}` : t('sessions')}
        hasBack={true}
      />
      <SessionsData />
    </Page>
  );
}

export default Sessions;
